import {WebGLBrandedDivider, type BrandedDividerParams} from '@github-ui/brand-webgl'
import type {Brand} from '../../types'

export type BrandedDividerProps = {
  brand?: Brand
  className?: string
  /**
   * Opt into compensating the WebGL canvas transform for the WebGLPage
   * wrapper's viewport offset. Pass `true` when the divider sits deep in the
   * document (e.g. below other sections) so the WebGL canvas paints at the
   * correct vertical position instead of being offset.
   */
  offsetByWrapperTop?: boolean
}

// Maps the Contentful `brand` enum (Copilot/Security) to WebGL params.
// New brands added in Contentful must be wired up here.
const BRAND_PARAMS: Record<Brand, BrandedDividerParams> = {
  Copilot: {character: 'copilot', layout: 0},
  Security: {character: 'security', layout: 0},
}

export const BrandedDivider = ({className, brand, offsetByWrapperTop}: BrandedDividerProps = {}) => {
  if (!brand) return null
  return (
    <WebGLBrandedDivider
      key={brand}
      params={BRAND_PARAMS[brand]}
      className={className}
      offsetByWrapperTop={offsetByWrapperTop}
    />
  )
}
